class Therapy {
  constructor(params) {
    this.drugName = params.drugName;
    this.hasUrl = params.hasUrl;
    this.urlSuffix = params.urlSuffix;
  }
}

export { Therapy };
